import { AllRows, Columns, ReportData } from '../result.interface';


export function getFileExportPosicion(ctx: any, vrs: number): any {

    var exportFileEx = [];
    var bol_datos_ex = false;
    var column_config:Columns[] = [];

    var table_width = ctx.chkDateHour? 13:12;

    var nom_inf = "REPORTE DE POSICIÓN";
    /* if (vm.optionUser() == 445 ) {
      var nom_inf = "REPORTE DE LUMINARIAS";
    } */

    var allRows: AllRows[] = [
        {
          cells: [
            { value: nom_inf, colSpan: table_width, ...ctx.headerCellConfig }
          ],
          height: ctx.headerRowsHeight,
        },
        ...ctx.generateEmptyRowsForRowSpan(ctx.headerRowSpan, ctx.headerRowsHeight),
    ];

    var cc = 0;
    var codigo_cell_ch_width = "Codigo".length;
    var placa_cell_ch_width = "Placa".length;
    var status_cell_ch_width = "Status".length;
    var conductor_cell_ch_width = "Conductor".length;
    var vel_gps_cell_ch_width = "Velocidad GPS".length;
    var vel_can_cell_ch_width = "Velocidad CAN".length;
    var odometro_cell_ch_width = "Odometro".length;
    var geocerca_cell_ch_width = "Geocerca".length;
    var referencia_cell_ch_width = "Referencia".length;

    if(ctx.sortedData.length > 0) {
        bol_datos_ex = true;
        var rows:AllRows[] = [
          {
            cells: [
              { value: nom_inf, ...ctx.headerCellConfig, colSpan: table_width }
            ],
            height: ctx.headerRowsHeight,
          },
          ...ctx.generateEmptyRowsForRowSpan(ctx.headerRowSpan, ctx.headerRowsHeight),
          {
            cells: [
              { value: ctx.report_data.rep_subtitle , color: ctx.vehicleContentTextColor, background: ctx.vehicleContentBackground, vAlign: "center", hAlign: "center", fontSize: ctx.t2, colSpan: table_width, borderBottom: { color: ctx.headersBorderColor, size: ctx.headersBorderSize } },
            ],
            height: ctx.subHeaderRepPosicionHeight,
          }
        ];


        if(ctx.chkDateHour) {
          rows.push({
            cells: [
              { value: "Ítem", ...ctx.colHeaderConfig },
              { value: "Código", ...ctx.colHeaderConfig },
              { value: "Placa", ...ctx.colHeaderConfig },

            /*{ value: "Servicio", bold: true, color: "#ffffff", background: "#128fe8", vAlign: "center", hAlign: "center", fontSize: ctx.t3 },
              { value: "Origen", bold: true, color: "#ffffff", background: "#128fe8", vAlign: "center", hAlign: "center", fontSize: ctx.t3 },
              { value: "Destino", bold: true, color: "#ffffff", background: "#128fe8", vAlign: "center", hAlign: "center", fontSize: ctx.t3 }, */

              { value: "Fecha", ...ctx.colHeaderConfig },
              { value: "Hora", ...ctx.colHeaderConfig },

              { value: "Status", ...ctx.colHeaderConfig },
              { value: "Conductor", ...ctx.colHeaderConfig },

              { value: "Velocidad GPS", ...ctx.colHeaderConfig },
              { value: "Velocidad CAN", ...ctx.colHeaderConfig },
              { value: "Odómetro", ...ctx.colHeaderConfig },
              { value: "Ubicación", ...ctx.colHeaderConfig },
              { value: "Geocerca", ...ctx.colHeaderConfig },
              { value: "Referencia", ...ctx.colHeaderConfig },
              /* { value: "Zona Cercana", bold: true, color: "#ffffff", background: "#128fe8", vAlign: "center", hAlign: "center", fontSize: ctx.t3 },
              { value: "Latitud/Longitud", bold: true, color: "#ffffff", background: "#128fe8", vAlign: "center", hAlign: "center", fontSize: ctx.t3 } */

            ],
            height: ctx.colsHeaderHeight,
          });
          ctx.sortedData.forEach((item: { tramo:any, latitud: number; longitud: number; codigo: any; placa: any; convoy: any; origen: any; destino: any; fecha: any; estado: any; conductor: any; velocidad: string; velocidad_can: any; odometro:any; referencia: any; }, index: number) => {
            //var fh = item.fecha_final.split(" ");
            var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6);

            codigo_cell_ch_width = Math.max(codigo_cell_ch_width, (item.codigo??'').toString().length);
            placa_cell_ch_width = Math.max(placa_cell_ch_width, (item.placa??'').toString().length);
            status_cell_ch_width = Math.max(status_cell_ch_width, (item.estado??'').toString().length);
            conductor_cell_ch_width = Math.max(conductor_cell_ch_width, (item.conductor??'').toString().length);
            vel_gps_cell_ch_width = Math.max(vel_gps_cell_ch_width, ((item.velocidad??'')+" km/h").length);
            vel_can_cell_ch_width = Math.max(vel_can_cell_ch_width, ((item.velocidad_can??'')+" km/h").length);
            odometro_cell_ch_width = Math.max(odometro_cell_ch_width, (item.odometro??'').toString().length);
            geocerca_cell_ch_width = Math.max(geocerca_cell_ch_width, (item.tramo??'').toString().length);
            referencia_cell_ch_width = Math.max(referencia_cell_ch_width, (item.referencia??'').toString().length);

            rows.push({
              cells: [
                { value: index + 1, ...ctx.bodyRowsConfig },
                { value: item.codigo, ...ctx.bodyRowsConfig },
                { value: item.placa, ...ctx.bodyRowsConfig },

                /* { value: item.convoy, ...ctx.bodyRowsConfig },
                { value: item.origen, ...ctx.bodyRowsConfig },
                { value: item.destino, ...ctx.bodyRowsConfig }, */

                { value: ctx.isChe(item.fecha), format: "yyyy/mm/dd", ...ctx.bodyRowsConfig },
                { value: ctx.isChs(item.fecha), format: "hh:mm:ss", ...ctx.bodyRowsConfig },

                { value: item.estado, ...ctx.bodyRowsConfig },
                { value: item.conductor, ...ctx.bodyRowsConfig },
                { value: item.velocidad+" km/h", ...ctx.bodyRowsConfig },
                { value: item.velocidad_can+" km/h", ...ctx.bodyRowsConfig },
                { value: item.odometro, ...ctx.bodyRowsConfig },
                { formula:  'HYPERLINK("http://maps.google.com/maps?q='+ubicacion+'&amp;t=m","'+ubicacion+'")', color:'#0000FF', ...ctx.bodyRowsConfig },

                { value: item.tramo, ...ctx.bodyRowsConfig },
                { value: item.referencia, ...ctx.bodyRowsConfig },
              ],
              height: ctx.bodyRowsHeight,
            });
          });

          //********************** RESUMEN ****************************

        } else {
          rows.push({
            cells: [
              { value: "Ítem", ...ctx.colHeaderConfig },
              { value: "Código", ...ctx.colHeaderConfig },
              { value: "Placa", bold:  ctx.colsHeaderBold, color: ctx.colsHeaderTextColor, background: ctx.colsHeaderBackground, vAlign: "center", hAlign: "center", fontSize: ctx.t3, borderRight: { color: ctx.headersBorderColor, size: ctx.headersBorderSize }, borderLeft: { color: ctx.headersBorderColor, size: ctx.headersBorderSize } },

              /* { value: "Servicio", bold: true, color: "#ffffff", background: "#128fe8", vAlign: "center", hAlign: "center", fontSize: ctx.t3 },
              { value: "Origen", bold: true, color: "#ffffff", background: "#128fe8", vAlign: "center", hAlign: "center", fontSize: ctx.t3 },
              { value: "Destino", bold: true, color: "#ffffff", background: "#128fe8", vAlign: "center", hAlign: "center", fontSize: ctx.t3 }, */

              { value: "Fecha y Hora", bold:  ctx.colsHeaderBold, color: ctx.colsHeaderTextColor, background: ctx.colsHeaderBackground, vAlign: "center", hAlign: "center", fontSize: ctx.t3, borderRight: { color: ctx.headersBorderColor, size: ctx.headersBorderSize }, borderLeft: { color: ctx.headersBorderColor, size: ctx.headersBorderSize } },

              { value: "Status", bold:  ctx.colsHeaderBold, color: ctx.colsHeaderTextColor, background: ctx.colsHeaderBackground, vAlign: "center", hAlign: "center", fontSize: ctx.t3, borderRight: { color: ctx.headersBorderColor, size: ctx.headersBorderSize }, borderLeft: { color: ctx.headersBorderColor, size: ctx.headersBorderSize } },
              { value: "Conductor", ...ctx.colHeaderConfig },
              { value: "Velocidad GPS", bold:  ctx.colsHeaderBold, color: ctx.colsHeaderTextColor, background: ctx.colsHeaderBackground, vAlign: "center", hAlign: "center", fontSize: ctx.t3, borderRight: { color: ctx.headersBorderColor, size: ctx.headersBorderSize }, borderLeft: { color: ctx.headersBorderColor, size: ctx.headersBorderSize } },
              { value: "Velocidad CAN", bold:  ctx.colsHeaderBold, color: ctx.colsHeaderTextColor, background: ctx.colsHeaderBackground, vAlign: "center", hAlign: "center", fontSize: ctx.t3, borderRight: { color: ctx.headersBorderColor, size: ctx.headersBorderSize }, borderLeft: { color: ctx.headersBorderColor, size: ctx.headersBorderSize } },
              { value: "Odómetro", bold:  ctx.colsHeaderBold, color: ctx.colsHeaderTextColor, background: ctx.colsHeaderBackground, vAlign: "center", hAlign: "center", fontSize: ctx.t3, borderRight: { color: ctx.headersBorderColor, size: ctx.headersBorderSize }, borderLeft: { color: ctx.headersBorderColor, size: ctx.headersBorderSize } },
              { value: "Ubicación", bold:  ctx.colsHeaderBold, color: ctx.colsHeaderTextColor, background: ctx.colsHeaderBackground, vAlign: "center", hAlign: "center", fontSize: ctx.t3, borderRight: { color: ctx.headersBorderColor, size: ctx.headersBorderSize }, borderLeft: { color: ctx.headersBorderColor, size: ctx.headersBorderSize } },
              { value: "Geocerca", bold:  ctx.colsHeaderBold, color: ctx.colsHeaderTextColor, background: ctx.colsHeaderBackground, vAlign: "center", hAlign: "center", fontSize: ctx.t3, borderRight: { color: ctx.headersBorderColor, size: ctx.headersBorderSize }, borderLeft: { color: ctx.headersBorderColor, size: ctx.headersBorderSize } },
              { value: "Referencia", bold:  ctx.colsHeaderBold, color: ctx.colsHeaderTextColor, background: ctx.colsHeaderBackground, vAlign: "center", hAlign: "center", fontSize: ctx.t3, borderRight: { color: ctx.headersBorderColor, size: ctx.headersBorderSize }, borderLeft: { color: ctx.headersBorderColor, size: ctx.headersBorderSize } },
            ],
            height: ctx.colsHeaderHeight,
          });

          ctx.sortedData.forEach((item: { tramo:any, latitud: number; longitud: number; referencia: string; codigo: any; placa: any; convoy: any; origen: any; destino: any; fecha: any; estado: any; conductor: any; velocidad: string; velocidad_can: any; odometro:any; zonaCercana: any; }, index: number) => {
            var ubicacion = item.latitud + "," + item.longitud;
            var rreeff = ((item.referencia == "NN") ? '' : item.referencia);

            codigo_cell_ch_width = Math.max(codigo_cell_ch_width, (item.codigo??'').toString().length);
            placa_cell_ch_width = Math.max(placa_cell_ch_width, (item.placa??'').toString().length);
            status_cell_ch_width = Math.max(status_cell_ch_width, (item.estado??'').toString().length);
            conductor_cell_ch_width = Math.max(conductor_cell_ch_width, (item.conductor??'').toString().length);
            vel_gps_cell_ch_width = Math.max(vel_gps_cell_ch_width, ((item.velocidad??'')+" km/h").length);
            vel_can_cell_ch_width = Math.max(vel_can_cell_ch_width, ((item.velocidad_can??'')+" km/h").length);
            odometro_cell_ch_width = Math.max(odometro_cell_ch_width, (item.odometro??'').toString().length);
            geocerca_cell_ch_width = Math.max(geocerca_cell_ch_width, (item.tramo??'').toString().length);
            referencia_cell_ch_width = Math.max(referencia_cell_ch_width, (item.referencia??'').toString().length);

            rows.push({
              cells: [
                { value: index + 1, ...ctx.bodyRowsConfig },
                { value: item.codigo, ...ctx.bodyRowsConfig },
                { value: item.placa, ...ctx.bodyRowsConfig },

                /* { value: item.convoy, ...ctx.bodyRowsConfig },
                { value: item.origen, ...ctx.bodyRowsConfig },
                { value: item.destino, ...ctx.bodyRowsConfig }, */

                { value: ctx.isChe(item.fecha), format: "yyyy/mm/dd hh:mm:ss", ...ctx.bodyRowsConfig },

                { value: item.estado, ...ctx.bodyRowsConfig },
                { value: item.conductor, ...ctx.bodyRowsConfig },
                { value: item.velocidad+" km/h", ...ctx.bodyRowsConfig },
                { value: item.velocidad_can+" km/h", ...ctx.bodyRowsConfig },
                { value: item.odometro, ...ctx.bodyRowsConfig },
                { formula:  'HYPERLINK("http://maps.google.com/maps?q='+ubicacion+'&amp;t=m","'+ubicacion+'")', ...ctx.bodyRowsConfig },
                { value: item.tramo, ...ctx.bodyRowsConfig },
                { value: item.referencia, ...ctx.bodyRowsConfig },

              ],
              height: ctx.bodyRowsHeight,
            });
          });

          //********************** RESUMEN ****************************

        }

        column_config = [
          { width: ctx.w_item },
          { width: ctx.calculateColWidth(codigo_cell_ch_width) },
          { width: ctx.calculateColWidth(placa_cell_ch_width) },
        ];
        if(ctx.chkDateHour){
          column_config.push(
            { width: ctx.w_date },
            { width: ctx.w_hour },
          )
        } else {
          column_config.push(
            { width: ctx.w_date_and_hour },
          )
        }
        column_config.push({ width: ctx.calculateColWidth(status_cell_ch_width)});
        column_config.push({ width: ctx.calculateColWidth(conductor_cell_ch_width)});
        column_config.push({ width: ctx.calculateColWidth(vel_gps_cell_ch_width)});
        column_config.push({ width: ctx.calculateColWidth(vel_can_cell_ch_width)});
        column_config.push({ width: ctx.calculateColWidth(odometro_cell_ch_width)});
        column_config.push({ width: ctx.w_lat_long});
        column_config.push({ width: ctx.calculateColWidth(geocerca_cell_ch_width)});
        column_config.push({ width: ctx.calculateColWidth(referencia_cell_ch_width)});

        // //********************************************* excel version 1 *********************************
        if (vrs == 1) {
            exportFileEx.push({
              freezePane: {
                  rowSplit: ctx.headerRowSpan + 2
                },
              columns: column_config,
              title: "Resultado",//data[0][1],
              rows: rows
            });
        }
        // //********************************************* excel version 1 *********************************

        // //********************************************* excel version 2 *********************************
        if (vrs == 2) {
           rows.splice(0, ctx.headerRowSpan);
           rows.push(...ctx.spaceBetweenTables);
           allRows = allRows.concat(rows);
        }
        // //********************************************* excel version 2 *********************************


    };

    //********************************************* excel version 2 *********************************
    if (vrs == 2) {
        exportFileEx.push({
          freezePane: {
              rowSplit: ctx.headerRowSpan
            },
          columns: column_config,
          // [
          //   { width: 200 },{ width: 200 },{ width: 200 },{ width: 200 },{ width: 200 },
          //   { width: 200 },{ width: 200 },{ width: 200 },{ width: 200 },{ width: 200 },
          //   { width: 200 },{ width: 200 },{ width: 200 },{ width: 200 },{ width: 200 },
          //   { width: 200 },{ width: 200 },{ width: 200 },{ width: 200 },{ width: 200 },
          //   { width: 200 },{ width: 200 },{ width: 200 },{ width: 200 },{ width: 200 }
          // ],
          title: "Resultado",//data[0][1],
          rows: allRows
        });
    }
    //********************************************* excel version 2 *********************************

    console.log("===>exportFileEx getFileExportPosicion", exportFileEx);  
    if (bol_datos_ex) {
        return exportFileEx;
    } else {
        return [];
    }

  }
